import tw, { styled } from 'twin.macro';

export const Button = styled.button<{ direction: 'left' | 'right' }>`
  ${tw`bg-neutrals-n1`}
  ${tw`rounded-full`}
  ${tw`relative`}
  ${tw`p-[2px]`}
  ${tw`inline`}
  ${tw`w-[48px] h-[48px]`}
  ${tw`bg-secondary-s1`}
  &:not(:disabled):hover {
    ${tw`bg-ui-colours-ui2`}
  }
  &:disabled {
    ${tw`bg-opacity-50`}
    svg {
      ${tw`opacity-50`}
    }
  }

  path {
    ${tw`stroke-secondary-s1`}
  }
  &:hover path {
    ${tw`stroke-ui-colours-ui2`}
  }

  ${({ direction }) => direction === 'left' && tw`mr-[12px]`}
  ${({ direction }) => direction === 'right' && tw`ml-[12px]`}
`;

export const ButtonInner = styled.div`
  ${tw`rounded-full`}
  ${tw`w-full h-full`}
  ${tw`bg-neutrals-n1`}
  ${tw`py-[15px]`}
`;

export const Svg = styled.svg<{ direction: 'left' | 'right' }>`
  ${tw`mx-auto`}
  ${({ direction }) => direction === 'right' && tw`transform rotate-180`}
`;
